import { z } from 'zod'

/**
 * Fails fast on boot if a required VITE_* var is missing/malformed, instead of
 * surfacing as a confusing runtime error deep inside an API call or websocket connect.
 */
const envSchema = z.object({
  appName: z.string().min(1),
  apiBaseUrl: z.url(),
  reverbAppKey: z.string().min(1),
  reverbHost: z.string().min(1),
  reverbPort: z.coerce.number().int().positive(),
  reverbScheme: z.enum(['http', 'https']),
})

export const env = envSchema.parse({
  appName: import.meta.env.VITE_APP_NAME,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  reverbAppKey: import.meta.env.VITE_REVERB_APP_KEY,
  reverbHost: import.meta.env.VITE_REVERB_HOST,
  reverbPort: import.meta.env.VITE_REVERB_PORT,
  reverbScheme: import.meta.env.VITE_REVERB_SCHEME,
})
